import React from 'react';

import { TDiscoveryQuizAnswer } from '@lib/tools/discoveryQuiz/types';

import iconDefault from '@components/web/src/assets/legacy/icons/discovery_quiz_icon_default.svg';
import iconFalse from '@components/web/src/assets/legacy/icons/discovery_quiz_icon_false.svg';
import iconSelectedFalse from '@components/web/src/assets/legacy/icons/discovery_quiz_icon_selected_false.svg';
import iconSelectedTrue from '@components/web/src/assets/legacy/icons/discovery_quiz_icon_selected_true.svg';
import * as S from '@components/web/src/atoms/DiscoveryQuizAnswersItem/styles';
import { Image } from '@components/web/src/foundations/Image/Image';
import { Text } from '@components/web/src/foundations/Text/Text';

interface Props extends TDiscoveryQuizAnswer {
  isSelectedAnswer: boolean;
  handleItemClick: (event: React.MouseEvent<HTMLButtonElement>, selectedAnswerId: number) => void;
}

export const DiscoveryQuizAnswersItem = ({
  text,
  isCorrectAnswer,
  isSelectedAnswer = null,
  id,
  handleItemClick,
}: Props) => {
  let icon = iconDefault;
  let selectedAnswerSelector = '';
  let notSelectedAnswerSelector = '';

  if (isSelectedAnswer !== null) {
    if (isSelectedAnswer) {
      icon = isCorrectAnswer ? iconSelectedTrue : iconSelectedFalse;
      selectedAnswerSelector = isCorrectAnswer ? 'isSelectedTrue' : 'isSelectedFalse';
    } else {
      icon = isCorrectAnswer ? iconSelectedTrue : iconFalse;
      notSelectedAnswerSelector = 'isNotSelectedAnswer';
    }
  }

  return (
    <S.DiscoveryQuizAnswersItemContainer
      $isCorrectAnswer={isCorrectAnswer}
      $isSelectedAnswer={!!isSelectedAnswer}
      $notSelectedAnswerSelector={notSelectedAnswerSelector}
      $selectedAnswerSelector={selectedAnswerSelector}
      type="button"
      onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleItemClick(event, id)}
    >
      <Image alt="icon" height="16px" maxWidth="16px" minWidth="16px" src={icon} />
      <Text size="body2" text={text} weight="semibold" />
    </S.DiscoveryQuizAnswersItemContainer>
  );
};
